import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'
import { getViaCep } from '../../../utils/api/viacep'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { cepMask, cnpjMask, telefoneMask } from '../../../utils/masks'
import { useRef } from 'react'
import { numbersOnly } from '../../../utils/validacoes'

const retornaPontoVenda = (u = []) => ({
  idEmpresa: u?.[0] || undefined,
  acPrefeitura: u?.[1] || undefined,
  idPrefeitura: u?.[1]?.[0]?.[0] || undefined,
  dsNomeFantazia: u?.[2] || undefined,
  dsRazaoSocial: u?.[3] || undefined,
  nrCnpj: u?.[4] || undefined,
  nrInscricaoMunicipal: u?.[5] || undefined,
  nrInscricaoEstadual: u?.[6] || undefined,
  dsLogradouro: u?.[7] || undefined,
  nrLogradouro: u?.[8] || undefined,
  dsBairro: u?.[9] || undefined,
  cdCep: u?.[10] || undefined,
  dsEmail: u?.[11] || undefined,
  nrTelefone: u?.[12] || undefined,
})
const Edicao = ({ dados, voltar, idUsuario }) => {
  const formik = useRef(null)

  const salva = async (values) => {
    const payload = {
      ...values,
      idUsuario,
      cdCep: numbersOnly(values?.cdCep || ''),
      nrCnpj: numbersOnly(values?.nrCnpj || ''),
      nrTelefone: numbersOnly(values?.nrTelefone || ''),
      nrInscricaoMunicipal: String(values?.nrInscricaoMunicipal),
      nrInscricaoEstadual: String(values?.nrInscricaoEstadual),
      nrLogradouro: String(values?.nrLogradouro),
    }

    const res = await metodoPrograma('salva', payload)
    if (res.status) voltar()
  }

  const handleViaCep = async (e) => {
    const ref = formik.current

    ref.setFieldValue('cdCep', e?.target?.value)

    if (ref?.values?.cdCep !== e?.target?.value) {
      const resp = await getViaCep(e?.target?.value)
      ref.setFieldValue('dsLogradouro', resp?.logradouro)
      ref.setFieldValue('dsBairro', resp?.bairro)
    }
  }

  const handleNumbersValues = (e) => {
    const ref = formik.current

    ref.setFieldValue(e?.target?.name, numbersOnly(e?.target?.value || ''))
  }

  return (
    <Formik
      innerRef={formik}
      initialValues={retornaPontoVenda(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm, setFieldValue, values }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Prefeitura"
                metodo="buscaPrefeitura"
                value={values.acPrefeitura}
                onChange={(_, v) => {
                  setFieldValue('idPrefeitura', v?.[0]?.[0])
                  setFieldValue('acPrefeitura', v)
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dsNomeFantazia"
                label="Nome Fantasia"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                component={TextField}
                name="dsRazaoSocial"
                label="Razão Social"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrCnpj"
                label="CNPJ"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                InputProps={cnpjMask}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrInscricaoMunicipal"
                label="Inscrição Municipal"
                fullWidth
                onChange={handleNumbersValues}
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrInscricaoEstadual"
                label="Inscrção Estadual"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                onChange={handleNumbersValues}
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="cdCep"
                label="CEP"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                onChange={handleViaCep}
                InputProps={cepMask}
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsLogradouro"
                label="Logradouro"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: !!values?.dsLogradouro }}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrLogradouro"
                label="Nr. Logradouro"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                inputProps={{ maxLength: 5 }}
                onChange={handleNumbersValues}
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsBairro"
                label="Bairro"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: !!values?.dsBairro }}
              />
            </Grid>

            <Grid item xs={3}>
              <Field
                component={TextField}
                name="dsEmail"
                label="Email"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Field
                component={TextField}
                name="nrTelefone"
                label="Telefone"
                fullWidth
                margin="dense"
                variant="outlined"
                size="small"
                InputProps={telefoneMask}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default Edicao
